// extracted by mini-css-extract-plugin
export default {"iframeWrapper":"bV-z"};